<template>
    <div :ref="refName" class="rent-select-group" :style="{border: '1px solid '+selectColor}" @click="clickEvent" @mouseenter="changeArrow(1)" @mouseleave="changeArrow()">
        <span :style="{color: selectColor}" >
            {{selectText}}
            <img class="arrow" :style="{transform: 'rotate('+arrowRotate+'deg)'}" :src="arrowImg" />
        </span>
        <slot v-if="show"></slot>
    </div>
</template>
<script>
export default {
    name: 'RentSelect',
    data () {
        return {
            show: 0,
            selectColor: '#a8a5a4',
            arrowImg: require('../../assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            selectText: this.selectMsg,
            isChange: 0
        }
    },
    props: {
        selectMsg: {
            type: String,
            default: '請選擇'
        },
        refName: String,
        setDefault: Boolean
    },
    watch: {
        // selectText: function () {
        // },
        setDefault: function () {
            if(this.setDefault){
                // this.selectText = this.selectMsg
                this.isChange = 0
                this.selectColor = '#a8a5a4'
                this.this.changeArrow()
            }
        }
    },
    mounted () {
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(e.target != el)
            if( el.contains(e.target) != true){
                _this.dropUp();
                _this.changeArrow()
                if( _this.isChange == 0 ){
                    _this.selectColor = '#a8a5a4'
                }
            }
        })
    },
    methods: {
        dropDown: function () {
            this.show = 1;
        },
        dropUp: function () {
            this.show = 0;
        },
        changeArrow: function (color, rotate) {
            if( color == 1 ){
                this.arrowImg = require('../../assets/img/icon/arrow_down_black.svg')
            }else{
                if(this.show == 1 || this.isChange ==1){
                    this.arrowImg = require('../../assets/img/icon/arrow_down_black.svg')
                }else{
                    this.arrowImg = require('../../assets/img/icon/arrow_down_gray.svg')
                }
            }
            if( rotate == 1 ){
                this.arrowRotate = 180
            }else{
                if(this.show == 1){
                    this.arrowRotate = 180
                }else{
                    this.arrowRotate = 0
                }
                
            }
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
                this.isChange = 1
                this.changeArrow()
                
                // this.selectText = event.target.innerText.replace(/(<br[^>]*>|\s*)/g,'');
                let data = {
                    id: event.target.dataset.id,
                    name: event.target.dataset.name,
                    ref: this.refName
                };
                this.$emit('getId', data);
            }else{
                this.dropDown()
                this.changeArrow(1, 1)
                this.selectColor = '#676362'
            }
        }
    }
}
</script>
<style   lang="scss">
    .rent-select-group{
        position: relative;
        width: 196px;
        padding: 13px 16px;
        border: 1px solid #a8a5a4;
        border-radius: 4px;
        cursor: pointer;
        >span{
            display: block;
            height: 100%;
            display: flex;
            align-items: center;
            // color: #a8a5a4;
            // padding: 5px 10px;
            .arrow{
                position: absolute;
                right: 8px;
            }
        }
        .checkbox-group{
            position: absolute;
            // display: none; 
            width: 738px;
            height: 276px;
            padding: 20px 24px 7px 24px;
            border-radius: 4px;
            z-index: 6;
            left: -559px;
            top: 47px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            border: solid 1px #eeeeee;
            background-color: #f0f0f0;
            >div{
                display: flex;
                .column{
                    span.title{
                        display: block;
                        margin-bottom: 17px;
                        color: #676362;
                    }
                    >div{
                        margin-bottom: 17px;
                    }
                }
                
            }
            .column-1{
                width: 118px;
                margin-right: 65px;
            }
            .column-2{
                width: 81px;
                margin-right: 65px;
            }
            .column-3{
                width: 81px;
                margin-right: 65px;
            }
            .column-4{
                width: 67px;
                margin-right: 65px;
            }
        }
        ul{
            position: absolute;
            // display: none; 
            width: 100%;
            padding: 4px 0;
            border-radius: 4px;
            z-index: 6;
            left: -2px;
            top: 47px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            border: solid 1px #eeeeee;
            background-color: #f0f0f0;
            li{
                position: relative;
                padding: 12px 16px;
                cursor: pointer;
            }
            li:hover{
                background: #fff;

            }
        }
    }
    .rent-select-group:hover{
        border: 1px solid #676362 !important;
        span{
            color: #676362 !important;
        }
    }
   
    
</style>


// WEBPACK FOOTER //
// src/components/widge/RentSelectGroup.vue